module.exports = (Promise.resolve(__parcel__require__("./" + "RistrettoPlaying.d0af78ac.b92daad8.js"))).then(() => parcelRequire('5uhef'));